import LandingHeader from '@/pages/landing/Header';
import Hero from '@/pages/landing/Hero';
import IntroSection from '@/pages/landing/IntroSection';
import LogoSection from '@/pages/landing/LogoSection';
import WhatIsSection from '@/pages/landing/WhatIsSection';
import InsightSection from '@/pages/landing/InsightSection';
import WhyUseSection from '@/pages/landing/WhyUseSection';
import PerformanceSection from '@/pages/landing/PerformanceSection';
import TestimonialSection from '@/pages/landing/TestimonialSection';
import FAQSection from '@/pages/landing/FAQSection';
import CTASection from '@/pages/landing/CTASection';
import LandingFooter from '@/pages/landing/Footer';

export default function LandingPage() {
  return (
    <div>
      <LandingHeader />
      <Hero />
      <IntroSection />
      <LogoSection />
      <WhatIsSection />
      <InsightSection />
      <WhyUseSection />
      <PerformanceSection />
      <TestimonialSection />
      <FAQSection />
      <CTASection />
      <LandingFooter />
    </div>
  );
}

